import type { FaireProductEntity } from "../../entity_types/product";

export const p_xf6ybmz9x3: FaireProductEntity = {
  token: "p_xf6ybmz9x3",
  type: "product",
  name: "Red Aztec Print Arkansas Bracelet with AB Crystals",
  brandToken: "b_aogprgmpxh",
  brandName: "GRACE+EMMA by Southern Grace",
  imageUrl: "https://cdn.faire.com/fastly/502ae2bbf8fc17e196ea663a32de1c5dc49da9285babdf5e51c76791f1d1a2e4.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.39,
  description: "Discover the beauty and elegance of Southern Grace with our Red Aztec Print Arkansas Bracelet with AB Crystals. This beaded bracelet, designed with a one-size-fits-most approach, captures the spirit and strength of the South. Just like our clothing, it's a piece that can effortlessly transition from a day at the farm to a fantastic night out. Embrace your Southern values with this stunning accessory that's been crafted to make every woman look and feel her best. Enjoy the comfort and quality of Southern Grace at an affordable price.",
  tags: [],
  msrpDollars: 3.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:41.421Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
